var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-container" },
    [
      !_vm.$attrs.multiple
        ? _c(
            "el-select",
            _vm._b(
              {
                staticClass: "el-select-90",
                attrs: {
                  placeholder: "请选择保险公司",
                  filterable: true,
                  clearable: _vm.clearable,
                  disabled: _vm.disabled,
                  "filter-method": _vm.filterCompany
                },
                on: { clear: _vm.companyClear, change: _vm.supplierChange },
                model: {
                  value: _vm.form.supplierId,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "supplierId", $$v)
                  },
                  expression: "form.supplierId"
                }
              },
              "el-select",
              _vm.$attrs,
              false
            ),
            _vm._l(_vm.companies, function(item) {
              return _c("el-option", {
                key: item.Value,
                attrs: {
                  label: _vm.getLabel(item),
                  value: item.Value,
                  disabled: _vm.disableList.includes(item.value)
                }
              })
            }),
            1
          )
        : _c("ybl-multi-select", {
            attrs: {
              items: _vm.companies,
              props: _vm.jobnumProps,
              placeholder: "请选择保险公司",
              clearable: _vm.clearable,
              filterable: "",
              "filter-method": _vm.filterCompany,
              disableList: _vm.disableList
            },
            on: { change: _vm.supplierChange },
            model: {
              value: _vm.form.supplierId,
              callback: function($$v) {
                _vm.$set(_vm.form, "supplierId", $$v)
              },
              expression: "form.supplierId"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-778fe7fd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-778fe7fd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Company.vue
// module id = null
// module chunks = 